document.addEventListener('DOMContentLoaded', function () {
  var shareBtn = document.getElementById('referral-whatsapp-btn');
  var codeInput = document.getElementById('referral-code-input');

  if (!shareBtn || !codeInput) return;

  // Pre-fill code if passed via URL, e.g. /pages/referral?code=ROHAN100
  var urlParams = new URLSearchParams(window.location.search);
  var codeFromUrl = urlParams.get('code');
  if (codeFromUrl) {
    codeInput.value = codeFromUrl.trim().toUpperCase();
  }

  shareBtn.addEventListener('click', function () {
    var rawCode = codeInput.value.trim().toUpperCase();

    if (!rawCode) {
      alert('Please enter your referral code first.');
      codeInput.focus();
      return;
    }

    var storeOrigin = window.location.origin;
    var autoApplyLink = storeOrigin + '/discount/' + encodeURIComponent(rawCode) + '?redirect=/collections/all';

    var message =
      'Yo, copped this oversized tee from UNQUOTEED. Quality and fit are crazy.\n\n' +
      'Use my personal code ' + rawCode + ' to get flat ₹100 off your first tee:\n' +
      autoApplyLink;

    var whatsappUrl = 'https://api.whatsapp.com/send?text=' + encodeURIComponent(message);
    window.open(whatsappUrl, '_blank');
  });
});
